<template>
    <section class="layout-hero bg__hero-home">
        <div class="row layout-hero--container">
            <!-- <div class="col-12 hero--container-video p-0">
                <video autoplay muted loop id="myVideo" class="video-hero">
                    <source src="https://torbel.do/media/videos/torbel_video_v3.mp4" type="video/mp4">
                </video>
            </div> -->

            <div class="col-12 layout-hero--content d-none">
                <div class="container max-width-lg p-0">
                    <div class="row">
                        <div class="col-6 layout-hero--text">
                            <h1 class="animated slideInUp">
                                Déjanos gestionar tus problemas con tu Estructura Visual y Ahorro de Energía
                            </h1>
                            <a class="btn btn-light animated slideInUp"
                                href="https://api.whatsapp.com/send?phone=18294464033&text=¿Deseas realizar un proyecto? Déjalo en nuestras manos">
                                Contáctanos
                            </a>  
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    </section>
</template>
<script>

export default {
    name: 'hero'
}
</script>

<style lang="scss" scoped>
.layout-hero--container {
    flex-direction: column;
    justify-content:center;
    align-items:center;
    position: relative;

    .layout-hero--content {

        .hero--container-video {
            padding: 0px !important;
            overflow: hidden;
            max-height: 750px;
        }

        .layout-hero--text {
            @extend %flex__align-left;
            margin-top:-100px;
            padding-left:50px;

            h1 {
                font-size: $subtitle-font-size;
                font-weight:normal;
                text-align: left;
                margin-bottom: 2rem;
                line-height: 45px;        
            }
        }
    }
}   

.video-hero {
    width: 100%;
    height: 100%;
    position: relative;
    // top: -100px;
}

.bg-overlay {
    background: $primary-color;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    opacity: 0.5;
}

.layout-hero--container,
.bg__hero-home {
    min-height: 750px;
    height: 100%;
}
.bg__hero-home {
    background:url('../../assets/images/bg-luces-final.png');
    background-color: $primary-color;
    background-position: center 100%;
    background-size: cover;
    background-repeat: no-repeat;
    color: $white;
    text-align:center;
}
</style>
